import { Observable } from 'rxjs/Observable';

export const BULLETIN_CLEAR_SEARCH = 'BULLETIN_CLEAR_SEARCH';
export const BULLETIN_SEARCH = 'BULLETIN_SEARCH';
export const BULLETIN_SEARCH_SUCCESS = 'BULLETIN_SEARCH_SUCCESS';
export const BULLETIN_ERROR = 'BULLETIN_ERROR';

export const BulletinActions = {
    /*openSearch: () => {

    }*/
    clearSearch: ({ errorCallback }) => {
        return {
            type: BULLETIN_CLEAR_SEARCH,
            payload: { errorCallback },
        };
    },
    search: ({ http, model, form, params, method, errorCallback }) => {
        return {
            type: BULLETIN_SEARCH,
            payload: { http, model, form, params, method, errorCallback }
        };
    },
};

export const BulletinEpics = [
    // SEARCH BULLETIN
    ($action, store) => {
        return $action.ofType(BULLETIN_SEARCH).mergeMap(action => {
            const { http, model, form, params, method, errorCallback } = action.payload;
            const stream = model.getResource('default', 'find').call(http, form, [], [], method);
            return stream
                .map(data => {
                    return {
                        type: BULLETIN_SEARCH_SUCCESS,
                        payload: data,
                    };
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: BULLETIN_ERROR,
                        error
                    });
                });
        });
    }
];

const initialState = {
    search: {
        typeRecherche: 'B',
        anneeScolaire: null,
        periode: 1,
        nom: null,
        idDiscipline: null,
        idProfesseur: null,
        idCycle: null,
        idNiveau: null,
        isValide: null,
        isPartiellementValide: null,
        isNonValide: null,
        estNonEnvoye: null,
        // ExamenId options switch values wether it's exam or eval search
        //examenId: { exam: null, eval: null },
    },
    loading: false,
    show: null,
    edit: null,
    list: null,
    searchForm: null,
};

export const BulletinReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case BULLETIN_CLEAR_SEARCH:
            return {
                ...state,
                loading: false,
                searchForm: null,
                list: null,
            };
        case BULLETIN_SEARCH:
            return {
                ...state,
                loading: true,
                searchForm: action.payload.form,
            };
        case BULLETIN_SEARCH_SUCCESS:
            return { ...state, loading: false, list: action.payload };
        case BULLETIN_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/examen/models/bulletin.store.ts